export default "__VITE_ASSET__B$oklvGo__"